import React, { Component } from 'react';
import { NextButton } from '../components/NextButton';
import { PreviousButton } from '../components/PreviousButton';
import { LenderRow } from '../components/LenderRow';


interface IProps {
    gtmEvent(): void;
    prevStep(): void;
    nextStep(): void;
    cashback?: number;
}

export class SwitcherSavingNo extends Component<IProps, any> {

    componentDidMount(): void {
        this.props.gtmEvent();
    }

    render() {

        return (
            <header className="App-header">
                <h1 className='l'>Looks like you're on a low rate now,<br /><span className='doddltext'>let's make sure it stays that way!</span></h1>
                <div className='wrapper'>
                    <div className='row'>
                        <p>There are still some competitive long-term rates out there, and we know where to find them</p>
                    </div>
                    <div className='row'>
                        <h2><span className='doddltext'>Act now to lock in longer term security</span></h2>
                    </div>
                    <div className='row'>
                        <div className='button-group'>
                            <PreviousButton onClick={() => this.props.prevStep()} />
                            <NextButton onClick={() => this.props.nextStep()} />
                        </div>
                    </div>
                    <div className='row mt-2'>
                        <LenderRow showDisclaimer />
                    </div>
                </div>
            </header>
        );
    }
}
